import { defineComponent as _defineComponent } from 'vue'
import { VPopover } from "@/components/v-tooltip";
import {PopoverTooltipPlacement} from "@/typings/PopoverTooltipPlacement";

type vIconWithTooltipProps = {
  iStyle: string;
  iClass: string;
  tooltipContent: string;
  tooltipPlacement: PopoverTooltipPlacement
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vIconWithTooltip',
  props: {
    iStyle: { default: '' },
    iClass: { default: '' },
    tooltipContent: null,
    tooltipPlacement: { default: 'top' }
  },
  emits: ['iclick'],
  setup(__props: any, { emit }) {

const props = __props as { iStyle: string, iClass: string, tooltipContent: string, tooltipPlacement: PopoverTooltipPlacement };





return { __sfc: true,props, emit, VPopover }
}

})